import { faPhoneAlt } from "@fortawesome/pro-solid-svg-icons/";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useCountryValue } from "../Contexts/CountryContext";
import PhoneNumber from "../Host/PhoneNumber";
import DeviceSelector from "../Selectors/DeviceSelector";
import { FormattedMessage } from 'react-intl';
function SubBox1() {
  var state = useCountryValue()[0];
  switch (state.country) {
    case "at":
      return /*#__PURE__*/React.createElement("div", {
        className: "numberline c-number-display"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faPhoneAlt
      }), "\u00A0", /*#__PURE__*/React.createElement(PhoneNumber, null), "\u00A0", /*#__PURE__*/React.createElement("small", {
        className: "highlight2"
      }, " +\u00A0", /*#__PURE__*/React.createElement(FormattedMessage, {
        id: 'Durchwahl',
        defaultMessage: "Durchwahl"
      }), "*"), /*#__PURE__*/React.createElement("br", null));
    case "de":
      if (state.device === "mobile") {
        return /*#__PURE__*/React.createElement("div", {
          className: "numberline c-number-display"
        }, /*#__PURE__*/React.createElement(DeviceSelector, null), /*#__PURE__*/React.createElement("span", {
          className: "callnumber c-number-display__info"
        }, /*#__PURE__*/React.createElement(PhoneNumber, null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, " w\u00E4hlen und ", /*#__PURE__*/React.createElement("span", {
          className: 'highlight2'
        }, "PIN"), " deines ", /*#__PURE__*/React.createElement(FormattedMessage, {
          id: 'Girl',
          defaultMessage: "Girl"
        }), "s sagen", /*#__PURE__*/React.createElement("sup", null, "*"))));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "numberline c-number-display"
        }, /*#__PURE__*/React.createElement(DeviceSelector, null), /*#__PURE__*/React.createElement("span", {
          className: "callnumber c-number-display__info"
        }, /*#__PURE__*/React.createElement(PhoneNumber, null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", {
          className: "highlight2"
        }, " +\u00A0", /*#__PURE__*/React.createElement(FormattedMessage, {
          id: 'Durchwahl',
          defaultMessage: "Durchwahl"
        }), "* ")), /*#__PURE__*/React.createElement("br", null));
      }
    case "ch":
      return /*#__PURE__*/React.createElement("div", {
        className: "numberline c-number-display"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faPhoneAlt
      }), "\u00A0", /*#__PURE__*/React.createElement(PhoneNumber, null), "*", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, "und folge ", /*#__PURE__*/React.createElement(FormattedMessage, {
        id: 'answeisung',
        defaultMessage: "den Anweisungen"
      }), " des Systems, tippe dann ", /*#__PURE__*/React.createElement(FormattedMessage, {
        id: 'PIN.article',
        defaultMessage: "die"
      }), " ", /*#__PURE__*/React.createElement("span", {
        className: "highlight2"
      }, "PIN"), " ein."), /*#__PURE__*/React.createElement("br", null));
  }
}
export default SubBox1;